import React, { ReactNode } from 'react';

import { Text } from '@zapier/design-system';

type Props = {
  children: ReactNode;
};

function StepTitle(props: Props) {
  return (
    <Text margin="0 0 1em 0" tag="h1" type="PageHeader">
      {props.children}
    </Text>
  );
}

export default StepTitle;
